import { formatDistance } from 'date-fns';

import { Notification } from '@/types/notifications';

// Import UKG Ready logo
import ukgReadyLogo from '@/assets/integrations/ukg-ready-short-logo.svg';
import trinetPEOLogo from '@/assets/integrations/trinet/icon.svg';

export const getUnseenNotifications = (
  notifications: Notification[]
): string[] => {
  return notifications.filter(n => !n?.seenAt).map(n => n?.id);
};

export const hasUnseenNotifications = (
  notifications: Notification[]
): boolean => {
  return getUnseenNotifications(notifications).length > 0;
};

export const getCreatedAtFormatted = (createdAt?: string): string => {
  if (!createdAt) {
    return '';
  }
  const dateToday = new Date();
  const notificationDate = new Date(createdAt);

  return formatDistance(notificationDate, dateToday, {
    addSuffix: true,
  });
};

/**
 * Gets the Application logo for the integration provider.
 *
 * As part of NERV-4902, only UKG Ready was requested to be shown.
 *
 * For a new logo, just import the file from the assets folder and pass it to this map.
 *
 */
const mapHRISLogo = {
  'UKG Ready': ukgReadyLogo,
  'TriNet PEO': trinetPEOLogo,
};

export const getHRISLogo = (logo: string): string | undefined => {
  return mapHRISLogo[logo as keyof typeof mapHRISLogo];
};
